<h2 class="prompt-description truncate" matTooltip="Prompt action: {{promptProfile.action}}"
    matTooltipShowDelay="500">
  <span>
    <!--toDO quote not css right-->
    <mat-icon fontIcon="format_quote" class="quote-start"/>
    {{ promptProfile.displayName }}
    <mat-icon fontIcon="format_quote" class="quote-end"/>
  </span>
</h2>
<section class="config-container">
  <article>
    <ul class="flex-table scrollable-container">
      @if (cardContextEntity != promptProfile.entityType) {
        <li id="candidate-selection">
          @if (!jobSubmissionsLoading)  {
            @if (cardContextEntity == BullhornEntityType.JOB_ORDER) {
              <app-multi-entity-select
                [candidatesLabel]="StringUtils.pluraliseEntity(getEntityLabel(BullhornEntityType.CANDIDATE))"
                [jobSubmissionLabel]="getEntityLabel(BullhornEntityType.JOB_SUBMISSION)"
                [entities]="this.availableJobSubmissions"
                [chosenEntities]="this.selectedJobSubmission"
                (entitiesSelected)="jobSubmissionMultiSelected($event)"></app-multi-entity-select>
            }
            @if (cardContextEntity == BullhornEntityType.CANDIDATE) {
              <app-associated-entity-selector
                [jobOrderLabel]="getEntityLabel(BullhornEntityType.JOB_ORDER)"
                [entities]="this.availableJobSubmissions"
                (entitySelected)="jobSubmissionSelected($event)"></app-associated-entity-selector>
            }
          }
        </li>
      }
      <li class="full-width-child container">
        <div>
          <app-prompt-option-select
            icon="person"
            placeholder="Role"
            [options]="promptOptions.role"
            [selectedOption]="selected.role"
            (updateSelectedOption)="updatePromptOption($event, 'role')">
          </app-prompt-option-select>
        </div>
        <div>
          <app-prompt-option-select
            icon="interpreter_mode"
            placeholder="Tone"
            [options]="promptOptions.tone"
            [selectedOption]="selected.tone"
            (updateSelectedOption)="updatePromptOption($event, 'tone')">
          </app-prompt-option-select>
        </div>
        <div>
          <app-prompt-option-select
            icon="description"
            placeholder="Format"
            [options]="promptOptions.format"
            [selectedOption]="selected.format"
            (updateSelectedOption)="updatePromptOption($event, 'format')">
          </app-prompt-option-select>
        </div>
        <div>
          <app-prompt-option-select
            icon="square_foot"
            placeholder="Result Length"
            [options]="promptOptions.resultLength"
            [selectedOption]="selected.resultLength"
            (updateSelectedOption)="updatePromptOption($event, 'resultLength')">
          </app-prompt-option-select>
        </div>
        <div>
          <app-prompt-option-select
            icon="landscape"
            placeholder="Explanation Difficulty"
            [options]="promptOptions.explanationDifficulty"
            [selectedOption]="selected.explanationDifficulty"
            (updateSelectedOption)="updatePromptOption($event, 'explanationDifficulty')">
          </app-prompt-option-select>
        </div>
        <div>
          <app-prompt-option-select
            icon="language"
            placeholder="Output Language"
            [options]="promptOptions.outputLanguage"
            [selectedOption]="selected.outputLanguage"
            (updateSelectedOption)="updatePromptOption($event, 'outputLanguage')">
          </app-prompt-option-select>
        </div>
      </li>
      @if (promptProfile.fileFilter?.isFilterEnabled !== false && cardContextEntity !== BullhornEntityType.LEAD) {
        <li
          [ngClass]="{'disabled' : fileList.length === 0}">
          <mat-label class="with-icon"><mat-icon fontIcon="attach_file"></mat-icon>Files</mat-label>
          <div>
            <div id="attachment-container">
              @if (filesSelected.length === 0) {
                <span class="multi-select-placeholder">
                {{ fileList.length === 0 ? 'No files available...' : 'Bullhorn files...' }}</span>
              }
              <mat-select [disabled]="fileList.length === 0"
                          [(ngModel)]="filesSelected" (selectionChange)="buildFileListTooltip()"
                          multiple panelClass="attachment-dropdown" class="attachment-dropdown">
                <mat-select-trigger>
                  @if (filesSelected.length! > 0) {
                    {{ filesSelected[0]!.name.length > 20 ? (filesSelected[0]!.name | slice:0:20) + '...' : filesSelected[0]!.name }}
                  }
                  @if (filesSelected.length! > 1) {
                    <span>
                      (+{{ (filesSelected.length!) - 1 }} more)
                    </span>
                  }
                </mat-select-trigger>
                @for (file of fileList; track file) {
                  <mat-option [value]="file">
                    {{ file.name }}<span class="secondary-info">{{ file.type }}</span>
                  </mat-option>
                }
              </mat-select>
              <mat-checkbox id="file-data" [checked]="useFileData" (change)="setFile($event.checked)"
                            [matTooltip]="'Selecting this option will use the information from the files only'"
                            [matTooltipShowDelay]="500"
                            [disabled]="filesSelected.length === 0">
                File data only
              </mat-checkbox>
            </div>
          </div>
        </li>
      }
      @if (promptProfile.noteFilter?.isFilterEnabled !== false) {
        <li [ngClass]="{'disabled' : noteList.length === 0}">
          <mat-label class="with-icon"><mat-icon fontIcon="description" class="material-icons-outlined"></mat-icon>Notes</mat-label>
          <div>
            <div id="note_attachment-container">
              @if (notesSelected.length === 0) {
                <span class="multi-select-placeholder">
                {{ noteList.length === 0 ? 'No notes available...' : 'Bullhorn notes...' }}</span>
              }
              <mat-select [disabled]="noteList.length === 0"
                          [(ngModel)]="notesSelected" (selectionChange)="setNote()"
                          multiple panelClass="attachment-dropdown" class="attachment-dropdown">
                <mat-select-trigger>
                  @if (notesSelected.length! > 0) {
                    {{ notesSelected[0]!.action.length > 20 ? (notesSelected[0]!.action | slice:0:20) + '...' : notesSelected[0]!.action }}
                  }
                  @if (notesSelected.length! > 1) {
                    <span>
                      (+{{ (notesSelected.length!) - 1 }} more)
                    </span>
                  }
                </mat-select-trigger>
                @for (note of noteList; track note) {
                  <mat-option [value]="note">
                    {{ note.action }}<span
                    class="secondary-info">{{ convertDateFromUnix(note.dateLastModified) }}</span>
                  </mat-option>
                }
              </mat-select>
            </div>
          </div>
        </li>
      }
      <li>
        <mat-label class="with-icon"><mat-icon fontIcon="auto_awesome"></mat-icon>LLM (Large Language
          Model)
        </mat-label>
        <div class="basic-flex-container">
          <mat-select class="not-full-width" placeholder="Choose an LLM..." title=""
                      [disabled]="(modelList.length <= 1)" [(ngModel)]="selectedModel"
                      (selectionChange)="updatedSelectedModel($event)">
            @for (llm of modelList; track $index) {
              <mat-option [value]="llm">{{ llm }}</mat-option>
            }
          </mat-select>
          <!-- TODO: Don't do this includes check on the fly -->
          @if (selectedModel?.includes('gpt-4')) {
            <mat-icon fontIcon="info_outline" class="tooltip"
                      matTooltip="GPT-4 models can take a little longer to run" matTooltipShowDelay="500"></mat-icon>
          }
        </div>
        <div>
          <mat-checkbox id="anonymise" [(ngModel)]="promptProfile['anonymise']"
                        [matTooltip]="'Selecting this option will anonymise the response from AI Assist'">
            Anonymise
          </mat-checkbox>
        </div>
      </li>
    </ul>
  </article>
  <footer>
    <button theme="medium"
            [disabled]="(promptProfile.entityType == BullhornEntityType.JOB_SUBMISSION && selectedJobSubmission.length <= 0)"
            (click)="sendAiOptions()"
            matTooltipShowDelay="500" matTooltip="Generate a response for this prompt">
      <!-- TODO: DISABLED STATE-->
      <mat-icon fontIcon="auto_awesome" class="material-icons-outlined"></mat-icon>
      Generate
    </button>
  </footer>
</section>
